import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { configureStore, combineReducers, AnyAction } from "@reduxjs/toolkit";

import { ResetStateActionType } from "application/types/store";

import { errorSlice } from "common";

import globalSlice from "./global/slice";
import dealSlice from "./Deal/dealSlice";
import authSlice from "./Auth/authSlice";
import requestSlice from "./request/slice";
import previewerPDFSlice from "./PreviewerPDF/previewerPDFSlice";
import legalEntitySlice from "./LegalEntity/legalEntitySlice";

const reducer = combineReducers({
  error: errorSlice.reducer,
  deal: dealSlice,
  auth: authSlice,
  global: globalSlice,
  request: requestSlice,
  previewerPDF: previewerPDFSlice,
  legalEntity: legalEntitySlice,
});

const rootReducer: typeof reducer = (state: RootState | undefined, action: AnyAction) => {
  if (action.type === ResetStateActionType) {
    return reducer(undefined, action);
  }
  return reducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
